<template>
    <div>
        <h5>Banners</h5>
        <div class="mb-3 mt-3">
            <select v-model="banner_url" class="form-control mb-3" style="width:300px;" @change="change_url">
                <option v-for="url in urls" :value="url">
                    <template v-if="url == '/'">
                        Homepage
                    </template>
                    <template v-else>
                        {{ url }}
                    </template>
                </option>
            </select>
            <div class="d-flex align-items-center">
                <button class="btn btn-light mr-2" 
                v-for="(banner, index) in sale_send" 
                @click="selected_banner = index" 
                :class="{'active-banner': index == selected_banner}"
                v-if="banner.pivot.url == banner_url">
                    Banner {{ banner_numbers[index] }}
                </button>
                <button class="btn btn-info" @click="add_banner(), selected_banner = sale_send.length - 1">
                    <i class="fas fa-plus"></i> Add Banner
                </button>
            </div>            
            <div class="mt-3" v-for="(banner, index) in sale_send" v-show="index == selected_banner">
                <div class="d-flex">
                    <v-select v-model="banner_model[index]" :options="banner_list" label="name" style="width:400px;" @input="change_array(banner.pivot.id)">
                        <template v-slot:option="option">
                            <div class="d-flex align-items-center select-option">
                                <div class="select-banner mr-2">
                                    <img :src="option.sizes.desktop.jpg" class="w-100" />
                                </div>
                                <div>
                                    {{option.name }}
                                </div>
                            </div>
                        </template>
                    </v-select>
                    <button class="btn btn-danger ml-2" @click="delete_banner(index, banner.pivot.id), selected_banner = sale_send.length - 1">
                        <i class="far fa-trash-alt text-white"></i> Delete Banner
                    </button>
                </div>
                <div class="mt-4">Banner link:</div>
                <input type="text" class="form-control" style="width:300px" placeholder="Banner link" v-model="banner.pivot.link" @input="change_array(banner.pivot.id)">
                <h5 class="mt-2">Desktop</h5>
                <div class="d-flex mb-3">
                    <v-select v-model="sticker_model_desktop[index]" :options="sticker_list" label="name" style="width:300px;">
                        <template v-slot:option="option">
                            <div class="d-flex align-items-center select-option">
                                <div class="select-sticker mr-2">
                                    <img :src="option.images.svg" class="w-100" />
                                </div>
                                <div>
                                    {{option.name }}
                                </div>
                            </div>
                        </template>
                    </v-select>
                    <button class="btn btn-info ml-2" @click="add_sticker(index, 'desktop')">
                        <i class="fas fa-plus"></i> Add Sticker
                    </button>
                </div>
                <button class="btn btn-success btn-sm mb-2" @click="desk_text = !desk_text">
                    <template v-if="!desk_text">
                        Show Text Options <i class="fas fa-angle-down"></i>
                    </template>
                    <template v-else>
                        Hide Text Options <i class="fas fa-angle-up"></i>
                    </template>
                </button>
                <div v-show="desk_text">
                    <div class="d-flex mb-1 align-items-center">
                        <div class="mr-1">Text Colour:</div>
                        <div style="width:100px;" class="mr-2">
                            <input type="text" v-model="color" class="form-control">
                        </div>
                        <div style="width:36px;height:36px;" :style="'background:' + color" class="border border-secondary"></div>
                    </div>                                
                    <div class="d-flex align-items-center mb-1">
                        <div class="mr-1">Font:</div>
                        <select class="form-control" v-model="font_id" style="width: 200px;">
                            <option v-for="font in fonts" :value="font.id">{{ font.name }}</option>
                        </select>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <div class="mr-1">Font Weight:</div>
                        <select v-for="font in fonts" v-if="font.id == font_id" class="form-control" v-model="font_weight_id" style="width: 100px;">
                            <option v-for="weight in font.weights" :value="weight.id">{{ weight.weight }}</option>
                        </select>
                    </div>                
                    <div class="d-flex align-items-center mb-1">
                        <div class="mr-1">Font Style:</div>
                        <select class="form-control" v-model="font_style_id" style="width: 100px;">
                            <option v-for="fontStyle in fontStyles" :value="fontStyle.id" :key="fontStyle.id">{{ fontStyle.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="d-flex mb-1">
                    <input type="text" class="form-control" style="width:300px" placeholder="Banner Text" v-model="desktop_text">
                    <button class="btn btn-info ml-2" @click="add_text(index, 'desktop', 'text')">
                        <i class="fas fa-plus"></i> Add Text
                    </button>
                </div>
                <div class="d-flex mb-1">
                    <select class="form-control" v-model="text_model_desktop[index]" style="width: 300px;">
                        <option v-for="group in groups" :value="group">{{ group.name }}</option>
                    </select>
                    <button class="btn btn-info ml-2" @click="add_text(index, 'desktop', 'from')">
                        <i class="fas fa-plus"></i> Add From Price
                    </button>
                </div>
                <div class="d-flex align-items-center mb-1">
                    <div class="mr-1">Resize:</div>
                    <input v-model="resizable" type="checkbox" @change="resize_pick()">
                </div>
                <p class="font-weight-bold mb-1">Right click sticker/text to delete it</p>
                <div class="position-relative">                    
                    <img :src="banner_model[index].sizes.desktop.jpg" class="img-fluid" ref="banner_desktop">
                    <template v-for="(sticker, subindex) in banner.pivot.stickers" v-if="sticker.pivot.banner_size_id == 1">
                        <img :src="sticker.images.png" ref="sticker" class="sticker position-absolute border border-dark" style="z-index:1;left:0"
                        :data-index="index" :data-subindex="subindex"
                        :data-x="sticker.pivot.x" :data-y="sticker.pivot.y"
                        :style="'transform:translate(' + sticker.pivot.x + 'px, ' + sticker.pivot.y + 'px);width:' + sticker.pivot.width + 'px;'"
                        @click.right.prevent="delete_sticker(index, subindex, sticker.pivot.id, banner.pivot.id)"
                        @click.left="change_array(sticker.pivot.id, 'sticker')">
                    </template>
                    <template v-for="(text, subindex) in banner.pivot.texts" v-if="text.banner_size_id == 1">
                        <div 
                        :text="true"
                        ref="text"
                        :data-x="text.x" :data-y="text.y"
                        :data-index="index" :data-subindex="subindex"
                        class="sticker position-absolute border border-dark"
                        :class="text.font.font"
                        style="z-index:1;top:0;left:0;white-space: nowrap;"
                        :style="'font-size:' + text.font_size + 'px;line-height:' + text.font_size + 'px;transform:translate(' + text.x + 'px, ' + text.y + 'px);color:' + text.colour + ';font-weight:' + text.font_weight.weight + ';font-style:' + text.font_style.slug"
                        @click.right.prevent="delete_text(index, subindex, text.id, banner.pivot.id)"
                        @click.left="change_array(text.id, 'text')">
                            <template v-if="text.text == null">
                                <template v-if="sale.websites[0].id == 118">&euro;</template><template v-else>&pound;</template>9.99
                            </template>
                            <template v-else>
                                {{ text.text }}
                            </template>
                        </div>
                    </template>
                </div>
                <button class="btn btn-success btn-sm mt-2" v-if="has_text('desktop')" @click="edit_desk_text = !edit_desk_text">
                    <template v-if="!edit_desk_text">
                        Edit Banner Text <i class="fas fa-angle-down"></i>
                    </template>
                    <template v-else>
                        Hide Edit <i class="fas fa-angle-up"></i>
                    </template>
                </button>
                <div v-if="edit_desk_text">
                    <div v-for="(text, subindex) in banner.pivot.texts" v-if="text.banner_size_id == 1" class="d-flex mt-1">
                        <input v-model="text.text" class="form-control mr-2" style="width: 200px;" @keyup="change_array(text.id, 'text')" v-if="!text.group">
                        <select class="form-control mr-2" v-model="text.group.id" style="width: 200px;" v-else @change="change_array(text.id, 'text')">
                            <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
                        </select>
                        <input v-model="text.font_size" class="form-control mr-2" style="width: 100px;" @keyup="change_array(text.id, 'text')">
                        <select class="form-control mr-2" v-model="text.font.id" style="width: 200px;" @change="text.font.font = font_attr('font', text.font.id), change_array(text.id, 'text')">
                            <option v-for="font in fonts" :value="font.id">{{ font.name }}</option>
                        </select>
                        <select v-for="font in fonts" v-if="font.id == text.font.id" class="form-control mr-2" v-model="text.font_weight.id" style="width: 100px;" @change="text.font_weight.weight = font_attr('weight', text.font.id, text.font_weight.id), change_array(text.id, 'text')">
                            <option v-for="weight in font.weights" :value="weight.id">{{ weight.weight }}</option>
                        </select>
                        <select class="form-control mr-2" v-model="text.font_style.id" style="width: 100px;" @change="text.font_style.slug = font_attr('style', text.font_style.id), change_array(text.id, 'text')">
                            <option v-for="fontStyle in fontStyles" :value="fontStyle.id" :key="fontStyle.id">{{ fontStyle.name }}</option>
                        </select>
                        <div style="width:100px;" class="mr-2">
                            <input type="text" v-model="text.colour" class="form-control" @keyup="change_array(text.id, 'text')">
                        </div>
                        <div style="width:36px;height:36px;" :style="'background:' + text.colour" class="border border-secondary"></div>
                    </div>
                </div>
                <h5 class="mt-4">Mobile</h5>
                <div class="d-flex mb-3">
                    <v-select v-model="sticker_model_mobile[index]" :options="sticker_list" label="name" style="width:300px;">
                        <template v-slot:option="option">
                            <div class="d-flex align-items-center select-option">
                                <div class="select-sticker mr-2">
                                    <img :src="option.images.svg" class="w-100" />
                                </div>
                                <div>
                                    {{option.name }}
                                </div>
                            </div>
                        </template>
                    </v-select>
                    <button class="btn btn-info ml-2" @click="add_sticker(index, 'mobile')">
                        Add Sticker
                    </button>
                </div>
                <button class="btn btn-success btn-sm mb-2" @click="mob_text = !mob_text">
                    <template v-if="!mob_text">
                        Show Text Options <i class="fas fa-angle-down"></i>
                    </template>
                    <template v-else>
                        Hide Text Options <i class="fas fa-angle-up"></i>
                    </template>
                </button>
                <div v-show="mob_text">
                    <div class="d-flex mb-1 align-items-center">
                        <div class="mr-1">Text Colour:</div>
                        <div style="width:100px;" class="mr-2">
                            <input type="text" v-model="color" class="form-control">
                        </div>
                        <div style="width:36px;height:36px;" :style="'background:' + color" class="border border-secondary"></div>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <div class="mr-1">Font:</div>
                        <select class="form-control" v-model="font_id" style="width: 200px;">
                            <option v-for="font in fonts" :value="font.id">{{ font.name }}</option>
                        </select>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <div class="mr-1">Font Weight:</div>
                        <select v-for="font in fonts" v-if="font.id == font_id" class="form-control" v-model="font_weight_id" style="width: 100px;">
                            <option v-for="weight in font.weights" :value="weight.id">{{ weight.weight }}</option>
                        </select>
                    </div> 
                    <div class="d-flex align-items-center mb-1">
                        <div class="mr-1">Font Style:</div>
                        <select class="form-control" v-model="font_style_id" style="width: 100px;">
                            <option v-for="fontStyle in fontStyles" :value="fontStyle.id" :key="fontStyle.id">{{ fontStyle.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="d-flex mb-1">
                    <input type="text" class="form-control" style="width:300px" placeholder="Banner Text" v-model="mobile_text">
                    <button class="btn btn-info ml-2" @click="add_text(index, 'mobile', 'text')">
                        <i class="fas fa-plus"></i> Add Text
                    </button>
                </div>
                <div class="d-flex mb-1">
                    <select class="form-control" v-model="text_model_mobile[index]" style="width: 300px;">
                        <option v-for="group in groups" :value="group">{{ group.name }}</option>
                    </select>
                    <button class="btn btn-info ml-2" @click="add_text(index, 'mobile', 'from')">
                        <i class="fas fa-plus"></i> Add From Price
                    </button>
                </div>
                <div class="d-flex align-items-center mb-1">
                    <div class="mr-1">Resize:</div>
                    <input v-model="resizable" type="checkbox" @change="resize_pick()">
                </div>
                <p class="font-weight-bold mb-1">Right click sticker/text to delete it</p>
                <div class="position-relative">                    
                    <img :src="banner_model[index].sizes.mobile.jpg" class="img-fluid" ref="banner_mobile">
                    <template v-for="(sticker, subindex) in banner.pivot.stickers" v-if="sticker.pivot.banner_size_id == 2">
                        <img :src="sticker.images.png" ref="sticker" class="sticker position-absolute border border-dark" style="z-index:1;left:0"
                        :data-index="index" :data-subindex="subindex"
                        :data-x="sticker.pivot.x" :data-y="sticker.pivot.y"
                        :style="'transform:translate(' + sticker.pivot.x + 'px, ' + sticker.pivot.y + 'px);width:' + sticker.pivot.width + 'px;'"
                        @click.right.prevent="delete_sticker(index, subindex, sticker.pivot.id, banner.pivot.id)"
                        @click.left="change_array(sticker.pivot.id, 'sticker')">
                    </template>
                    <template v-for="(text, subindex) in banner.pivot.texts" v-if="text.banner_size_id == 2">
                        <div 
                        :text="true"
                        ref="text"
                        :data-x="text.x" :data-y="text.y"
                        :data-index="index" :data-subindex="subindex"
                        class="sticker position-absolute border border-dark"
                        :class="text.font.font"
                        style="z-index:1;top:0;left:0;white-space: nowrap;"
                        :style="'font-size:' + text.font_size + 'px;line-height:' + text.font_size + 'px;transform:translate(' + text.x + 'px, ' + text.y + 'px);color:' + text.colour + ';font-weight:' + text.font_weight.weight + ';font-style:' + text.font_style.slug"
                        @click.right.prevent="delete_text(index, subindex, text.id, banner.pivot.id)"
                        @click.left="change_array(text.id, 'text')">
                            <template v-if="text.text == null">
                                &pound;9.99
                            </template>
                            <template v-else>
                                {{ text.text }}
                            </template>
                        </div>
                    </template>
                </div>
                <button class="btn btn-success btn-sm mt-2" v-if="has_text('mobile')" @click="edit_mob_text = !edit_mob_text">
                    <template v-if="!edit_mob_text">
                        Edit Banner Text <i class="fas fa-angle-down"></i>
                    </template>
                    <template v-else>
                        Hide Edit <i class="fas fa-angle-up"></i>
                    </template>
                </button>
                <div v-if="edit_mob_text">
                    <div v-for="text in banner.pivot.texts" v-if="text.banner_size_id == 2" class="d-flex mt-1">
                        <input v-model="text.text" class="form-control mr-2" style="width: 200px;" @keyup="change_array(text.id, 'text')" v-if="text.group != null">
                        <select class="form-control" v-model="text.group.id" style="width: 200px;" v-else @change="change_array(text.id, 'text')">
                            <option v-for="group in groups" :value="group">{{ group.name }}</option>
                        </select>
                        <input v-model="text.font_size" class="form-control mr-2" style="width: 100px;" @keyup="change_array(text.id, 'text')">
                        <select class="form-control mr-2" v-model="text.font.id" style="width: 200px;" @change="text.font.font = font_attr('font', text.font.id), change_array(text.id, 'text')">
                            <option v-for="font in fonts" :value="font.id">{{ font.name }}</option>
                        </select>
                        <select v-for="font in fonts" v-if="font.id == text.font.id" class="form-control mr-2" v-model="text.font_weight.id" style="width: 100px;" @change="text.font_weight.weight = font_attr('weight', text.font.id, text.font_weight.id), change_array(text.id, 'text')">
                            <option v-for="weight in font.weights" :value="weight.id">{{ weight.weight }}</option>
                        </select>
                        <select class="form-control mr-2" v-model="text.font_style.id" style="width: 100px;" @change="text.font_style.slug = font_attr('style', text.font_style.id), change_array(text.id, 'text')">
                            <option v-for="fontStyle in fontStyles" :value="fontStyle.id" :key="fontStyle.id">{{ fontStyle.name }}</option>
                        </select>
                        <div style="width:100px;" class="mr-2">
                            <input type="text" v-model="text.colour" class="form-control" @keyup="change_array(text.id, 'text')">
                        </div>
                        <div style="width:36px;height:36px;" :style="'background:' + text.colour" class="border border-secondary"></div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <button class="btn btn-danger mr-1" @click="closeSection"><i class="far fa-times-circle"></i>&nbsp; Close</button>
            <button class="btn btn-primary mr-1" @click="save()"><i class="far fa-save"></i>&nbsp; Save</button>
            <button class="btn btn-success" @click="save('close')"><i class="fas fa-save"></i>&nbsp; Save &amp; close</button> 
        </div>
        <loader :loading="loading"></loader>
    </div>
</template> 

<script>

import loader from './loader';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {

    components: {
        loader,
        vSelect,
    },

    data() {
        return {
            banner_url: '/',
            sticker_list: [],
            banner_list: [],
            groups: [],
            sale_send: [],
            prev_sale: [],
            banner_model: [],
            sticker_model_desktop: [],
            sticker_model_mobile: [],
            text_model_desktop: [],
            text_model_mobile: [],
            selected_banner: 0,
            banner_numbers: [],

            changed: [],
            changed_stickers: [], 
            changed_text: [],        
            deleted:[],
            deleted_sticker_ids:[],
            deleted_sticker_banner_ids:[],
            deleted_text_ids:[],
            deleted_text_banner_ids:[],

            load_count: 0,
            load_count_stickers_text: 0,
            loading: true,

            desktop_text: '',
            mobile_text: '',

            color: '#000000',

            axios_array: [],
            axios_array_sticker_text: [],

            resizable: true,
            fonts: [],
            fontStyles: [],
            font_id: 1,
            font_weight_id: 3,
            font_style_id: 1,

            desk_text: false,
            mob_text: false,
            edit_desk_text: false,
            edit_mob_text: false,
        };
    },

    props: {
        sale: Object,
        urls: Array,
    },

    mounted(){
        this.sale_send = this.sale.banners;
        this.on_load();
        history.pushState({page: 0}, "", window.location.pathname + "?page=banners");          
        this.update_banners();  
        this.banner_number();           
    },

    methods: { 
        banner_number() {   
            let count = 0; 
            let bannerUrl = false;
            this.banner_numbers = [];
            for(let banner in this.sale_send){
                if(this.sale_send[banner].pivot.url != bannerUrl){
                    count = 0;
                    bannerUrl = this.sale_send[banner].pivot.url;
                }
                count++;
                this.banner_numbers.push(count);
            }       
        },
        save(close) {
            this.prev_sale = this.sale_send;
            this.loading_count();
            this.loading_count_stickers_text();
            if(this.load_count > 0){
                this.loading = true;                
            } else if(this.load_count_stickers_text > 0){
                this.loading = true;
                this.save_stickers_text();
            } else if(close){
                this.closeSection();
            }
            if(this.deleted.length > 0){
                for(let del in this.deleted){
                    this.axios_array.push(axios.delete('/sales/' + this.sale.id + '/banners/' + this.deleted[del]))
                }
            }
            if(this.deleted_sticker_ids.length > 0){                
                for(let del in this.deleted_sticker_ids){
                    this.axios_array.push(axios.delete('/sales/' + this.sale.id + '/banners/' + this.deleted_sticker_banner_ids[del] + '/stickers/' + this.deleted_sticker_ids[del]))
                }
            }
            if(this.deleted_text_ids.length > 0){                
                for(let del in this.deleted_text_ids){
                    this.axios_array.push(axios.delete('/sales/' + this.sale.id + '/banners/' + this.deleted_text_banner_ids[del] + '/texts/' + this.deleted_text_ids[del]))
                }
            }
            for(let banner in this.sale_send){
                if(this.changed.includes(this.sale_send[banner].pivot.id) && this.sale_send[banner].pivot.id){
                    this.axios_array.push(
                        axios.patch('/sales/' + this.sale.id + '/banners/' + this.sale_send[banner].pivot.id,{
                            banner_id: this.banner_model[banner].id,
                            sort: banner,
                            url: this.sale_send[banner].pivot.url,
                            link: this.sale_send[banner].pivot.link
                        })
                    )
                } else if(!this.sale_send[banner].pivot.id){
                    this.axios_array.push(
                        axios.post('/sales/' + this.sale.id + '/banners', {
                            banner_id: this.banner_model[banner].id,
                            sort: banner,
                            url: this.sale_send[banner].pivot.url,
                            link: this.sale_send[banner].pivot.link
                        })
                    )
                }                
            }
            axios.all(this.axios_array)            
            .then(function (responses){   
                if(responses.length > 0){   
                    axios.get('/sales/' + this.sale.id)
                    .then(function (response) {
                        this.sale_send = response.data.sale.banners;                    
                        this.load_banners(close);               
                    }.bind(this))
                    .catch(function (error) {
                        alert(error.message);
                    })                
                }
            }.bind(this));
        },
        save_stickers_text(){
            let sticker_x;
            let sticker_y;
            let sticker_width;
            let sticker_height;
            let text_x;
            let text_y;
            let text_width;
            let text_height;
            let font_size;
            let group = null;
            for(let banner in this.prev_sale){
                for(let sticker in this.prev_sale[banner].pivot.stickers){
                    if(this.prev_sale[banner].pivot.stickers[sticker].pivot.banner_size_id == 1){
                        sticker_x = this.post_adjust(this.prev_sale[banner].pivot.stickers[sticker].pivot.x);
                        sticker_y = this.post_adjust(this.prev_sale[banner].pivot.stickers[sticker].pivot.y);
                        sticker_width = this.post_adjust(this.prev_sale[banner].pivot.stickers[sticker].pivot.width);
                        sticker_height = this.post_adjust(this.prev_sale[banner].pivot.stickers[sticker].pivot.height);
                    }
                    else if(this.prev_sale[banner].pivot.stickers[sticker].pivot.banner_size_id == 2){
                        sticker_x = this.post_adjust_mob(this.prev_sale[banner].pivot.stickers[sticker].pivot.x);
                        sticker_y = this.post_adjust_mob(this.prev_sale[banner].pivot.stickers[sticker].pivot.y);
                        sticker_width = this.post_adjust_mob(this.prev_sale[banner].pivot.stickers[sticker].pivot.width);
                        sticker_height = this.post_adjust_mob(this.prev_sale[banner].pivot.stickers[sticker].pivot.height);
                    }
                    if(this.changed_stickers.includes(this.prev_sale[banner].pivot.stickers[sticker].pivot.id) && this.prev_sale[banner].pivot.stickers[sticker].pivot.id){
                        this.axios_array_sticker_text.push(
                            axios.patch('/sales/' + this.sale.id + '/banners/' + this.sale_send[banner].pivot.id + '/stickers/' + this.prev_sale[banner].pivot.stickers[sticker].pivot.id,{
                                x: sticker_x,
                                y: sticker_y,
                                width: sticker_width,
                                height: sticker_height
                            })
                        )
                    } else if(!this.prev_sale[banner].pivot.stickers[sticker].pivot.id){
                        this.axios_array_sticker_text.push(
                            axios.post('/sales/' + this.sale.id + '/banners/' + this.sale_send[banner].pivot.id + '/stickers',{
                                sticker_id: this.prev_sale[banner].pivot.stickers[sticker].id,
                                banner_size_id: this.prev_sale[banner].pivot.stickers[sticker].pivot.banner_size_id,
                                x: sticker_x,
                                y: sticker_y,
                                width: sticker_width,
                                height: sticker_height
                            })
                        )
                    }                    
                }
                for(let text in this.prev_sale[banner].pivot.texts){
                   if(this.prev_sale[banner].pivot.texts[text].banner_size_id == 1){
                        text_x = this.post_adjust(this.prev_sale[banner].pivot.texts[text].x);
                        text_y = this.post_adjust(this.prev_sale[banner].pivot.texts[text].y);
                        text_width = this.post_adjust(this.prev_sale[banner].pivot.texts[text].width);
                        text_height = this.post_adjust(this.prev_sale[banner].pivot.texts[text].height);
                        font_size = this.post_adjust(this.prev_sale[banner].pivot.texts[text].font_size);
                    }
                    else if(this.prev_sale[banner].pivot.texts[text].banner_size_id == 2){
                        text_x = this.post_adjust_mob(this.prev_sale[banner].pivot.texts[text].x);
                        text_y = this.post_adjust_mob(this.prev_sale[banner].pivot.texts[text].y);
                        text_width = this.post_adjust_mob(this.prev_sale[banner].pivot.texts[text].width);
                        text_height = this.post_adjust_mob(this.prev_sale[banner].pivot.texts[text].height);
                        font_size = this.post_adjust_mob(this.prev_sale[banner].pivot.texts[text].font_size);
                    }
                    text_y += text_height;
                    if(this.prev_sale[banner].pivot.texts[text].group != null){
                        group = this.prev_sale[banner].pivot.texts[text].group.id
                    } 
                    if(this.changed_text.includes(this.prev_sale[banner].pivot.texts[text].id) && this.prev_sale[banner].pivot.texts[text].id){
                        this.axios_array_sticker_text.push(
                            axios.patch('/sales/' + this.sale.id + '/banners/' + this.sale_send[banner].pivot.id + '/texts/' + this.prev_sale[banner].pivot.texts[text].id,{
                                x: text_x,
                                y: text_y,
                                width: text_width,
                                height: text_height,
                                font_size: font_size,
                                font_id: this.prev_sale[banner].pivot.texts[text].font.id,
                                font_style_id: this.prev_sale[banner].pivot.texts[text].font_style.id,
                                font_weight_id: this.prev_sale[banner].pivot.texts[text].font_weight.id,
                                colour: this.prev_sale[banner].pivot.texts[text].colour,
                                text: this.prev_sale[banner].pivot.texts[text].text,
                                group_id: group,
                            })
                        )
                    } else if(!this.prev_sale[banner].pivot.texts[text].id){
                        this.axios_array_sticker_text.push(
                            axios.post('/sales/' + this.sale.id + '/banners/' + this.sale_send[banner].pivot.id + '/texts',{
                                x: text_x,
                                y: text_y,
                                width: text_width,
                                height: text_height,
                                font_size: font_size,
                                font_id: this.prev_sale[banner].pivot.texts[text].font.id,
                                font_style_id: this.prev_sale[banner].pivot.texts[text].font_style.id,
                                font_weight_id: this.prev_sale[banner].pivot.texts[text].font_weight.id,
                                colour: this.prev_sale[banner].pivot.texts[text].colour,
                                text: this.prev_sale[banner].pivot.texts[text].text,
                                group_id: group,
                                banner_size_id: this.prev_sale[banner].pivot.texts[text].banner_size_id,
                            })
                        )
                    }          
                }
            }
            axios.all(this.axios_array_sticker_text)            
            .then(function (responses){   
                if(responses.length > 0){   
                    axios.get('/sales/' + this.sale.id)
                    .then(function (response) {
                        this.sale_send = response.data.sale.banners;                    
                        this.update_banners();
                        this.load_stickers_text(close);                                       
                    }.bind(this))
                    .catch(function (error) {
                        alert(error.message);
                    })                
                }
            }.bind(this));
        },
        update_banners(add){  
            if(add == 'add_banner'){
                this.banner_model.push(
                    this.sale_send[0],
                );
            } else {
                this.banner_model = [];            
                for(let banner in this.sale_send){
                    this.banner_model.push(
                        this.sale_send[banner],
                    );
                }
            }
        },
        update_stickers(){  
            this.sticker_model_desktop = [];
            this.sticker_model_mobile = [];
            for(let banner in this.sale_send){
                this.sticker_model_desktop.push(
                    this.sticker_list[0],
                );
                this.sticker_model_mobile.push(
                    this.sticker_list[0],
                );
            }
        },
        update_text(){  
            this.text_model_desktop = [];
            this.text_model_mobile = [];
            for(let banner in this.sale_send){
                this.text_model_desktop.push( 
                    this.groups[0],
                );
                this.text_model_mobile.push(
                    this.groups[0],
                );
            }
        },
        on_load(){
            let loadcount = 0;
            axios.get('/media-centre/stickers/list')
            .then(function (response) {    
                this.check_on_load(loadcount++); 
                this.sticker_list = response.data.stickers.data;   
                axios.get('/media-centre/banners/list')
                .then(function (response) {
                    this.check_on_load(loadcount++);
                    this.banner_list = response.data.banners.data;   
                    axios.get('/groups/list')
                        .then(function (response) {
                        this.check_on_load(loadcount++);
                        this.groups = response.data.groups;
                        axios.get('/fonts/list')
                            .then(function (response) {
                            this.check_on_load(loadcount++);
                            this.fonts = response.data.fonts;
                            this.fontStyles = response.data.font_styles;
                        }.bind(this))
                        .catch(function (error) {
                            // handle error
                            alert(error.message);
                        })
                    }.bind(this))
                    .catch(function (error) {
                        // handle error
                        alert(error.message);
                    })
                }.bind(this))
                .catch(function (error) {
                    // handle error
                    alert(error.message);
                })             
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error.message);
            })                                                
        },
        check_on_load(loadcount){
            if(loadcount == 2){
                this.$nextTick(function () {
                    this.loading = false;
                    this.update_stickers();
                    this.update_text();
                    this.adjust_points();
                    this.sticker_interaction();
                });
            }
        },
        adjust_points(){
            for(let banner in this.sale_send){
                for(let sticker in this.sale_send[banner].pivot.stickers){
                    if(this.sale_send[banner].pivot.stickers[sticker].pivot.banner_size_id == 1){
                        this.sale_send[banner].pivot.stickers[sticker].pivot.x = this.adjust(this.sale_send[banner].pivot.stickers[sticker].pivot.x);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.y = this.adjust(this.sale_send[banner].pivot.stickers[sticker].pivot.y);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.width = this.adjust(this.sale_send[banner].pivot.stickers[sticker].pivot.width);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.height = this.adjust(this.sale_send[banner].pivot.stickers[sticker].pivot.height);
                    } else {
                        this.sale_send[banner].pivot.stickers[sticker].pivot.x = this.adjust_mob(this.sale_send[banner].pivot.stickers[sticker].pivot.x);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.y = this.adjust_mob(this.sale_send[banner].pivot.stickers[sticker].pivot.y);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.width = this.adjust_mob(this.sale_send[banner].pivot.stickers[sticker].pivot.width);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.height = this.adjust_mob(this.sale_send[banner].pivot.stickers[sticker].pivot.height);
                    }
                }
                for(let text in this.sale_send[banner].pivot.texts){
                    if(this.sale_send[banner].pivot.texts[text].banner_size_id == 1){
                        this.sale_send[banner].pivot.texts[text].x = this.adjust(this.sale_send[banner].pivot.texts[text].x);
                        this.sale_send[banner].pivot.texts[text].y = this.adjust(this.sale_send[banner].pivot.texts[text].y);                        
                        this.sale_send[banner].pivot.texts[text].font_size = this.adjust(this.sale_send[banner].pivot.texts[text].font_size);
                        this.sale_send[banner].pivot.texts[text].width = this.adjust(this.sale_send[banner].pivot.texts[text].width);
                        this.sale_send[banner].pivot.texts[text].height = this.adjust(this.sale_send[banner].pivot.texts[text].height);
                    } else {
                        this.sale_send[banner].pivot.texts[text].x = this.adjust_mob(this.sale_send[banner].pivot.texts[text].x);
                        this.sale_send[banner].pivot.texts[text].y = this.adjust_mob(this.sale_send[banner].pivot.texts[text].y);                        
                        this.sale_send[banner].pivot.texts[text].font_size = this.adjust_mob(this.sale_send[banner].pivot.texts[text].font_size);
                        this.sale_send[banner].pivot.texts[text].width = this.adjust_mob(this.sale_send[banner].pivot.texts[text].width);
                        this.sale_send[banner].pivot.texts[text].height = this.adjust_mob(this.sale_send[banner].pivot.texts[text].height);
                    }
                    this.sale_send[banner].pivot.texts[text].y -= this.sale_send[banner].pivot.texts[text].height;
                } 
            }
        },
        destroy_adjust_points(){
            for(let banner in this.sale_send){
                for(let sticker in this.sale_send[banner].pivot.stickers){
                    if(this.sale_send[banner].pivot.stickers[sticker].pivot.banner_size_id == 1){
                        this.sale_send[banner].pivot.stickers[sticker].pivot.x = this.post_adjust(this.sale_send[banner].pivot.stickers[sticker].pivot.x);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.y = this.post_adjust(this.sale_send[banner].pivot.stickers[sticker].pivot.y);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.width = this.post_adjust(this.sale_send[banner].pivot.stickers[sticker].pivot.width);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.height = this.post_adjust(this.sale_send[banner].pivot.stickers[sticker].pivot.height);
                    } else {
                        this.sale_send[banner].pivot.stickers[sticker].pivot.x = this.post_adjust_mob(this.sale_send[banner].pivot.stickers[sticker].pivot.x);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.y = this.post_adjust_mob(this.sale_send[banner].pivot.stickers[sticker].pivot.y);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.width = this.post_adjust_mob(this.sale_send[banner].pivot.stickers[sticker].pivot.width);
                        this.sale_send[banner].pivot.stickers[sticker].pivot.height = this.post_adjust_mob(this.sale_send[banner].pivot.stickers[sticker].pivot.height);
                    }
                } 
                for(let text in this.sale_send[banner].pivot.texts){
                    if(this.sale_send[banner].pivot.texts[text].banner_size_id == 1){
                        this.sale_send[banner].pivot.texts[text].x = this.post_adjust(this.sale_send[banner].pivot.texts[text].x);
                        this.sale_send[banner].pivot.texts[text].y = this.post_adjust(this.sale_send[banner].pivot.texts[text].y);                        
                        this.sale_send[banner].pivot.texts[text].font_size = this.post_adjust(this.sale_send[banner].pivot.texts[text].font_size);
                        this.sale_send[banner].pivot.texts[text].width = this.post_adjust(this.sale_send[banner].pivot.texts[text].width);
                        this.sale_send[banner].pivot.texts[text].height = this.post_adjust(this.sale_send[banner].pivot.texts[text].height);
                    } else {
                        this.sale_send[banner].pivot.texts[text].x = this.post_adjust_mob(this.sale_send[banner].pivot.texts[text].x);
                        this.sale_send[banner].pivot.texts[text].y = this.post_adjust_mob(this.sale_send[banner].pivot.texts[text].y);                        
                        this.sale_send[banner].pivot.texts[text].font_size = this.post_adjust_mob(this.sale_send[banner].pivot.texts[text].font_size);
                        this.sale_send[banner].pivot.texts[text].width = this.post_adjust_mob(this.sale_send[banner].pivot.texts[text].width);
                        this.sale_send[banner].pivot.texts[text].height = this.post_adjust_mob(this.sale_send[banner].pivot.texts[text].height);
                    }
                    this.sale_send[banner].pivot.texts[text].y -= this.sale_send[banner].pivot.texts[text].height;
                } 
            }
        },
        load_banners(close){
            this.changed = [];
            this.deleted = [];
            this.deleted_sticker_ids = [];
            this.deleted_sticker_banner_ids = [];
            this.deleted_text_ids = [];
            this.deleted_text_banner_ids = [];
            this.load_count = 0;
            this.axios_array = [];
            this.$nextTick(function () {
                this.update_banners();
                this.update_stickers();
                this.update_text();
                this.adjust_points();
                this.sticker_interaction();
                this.save_stickers_text(); 
                if(this.load_count_stickers_text == 0){
                    this.loading = false;
                }              
                if(close == 'close' && this.load_count_stickers_text == 0){
                    this.closeSection();
                }
            })  
        },
        load_stickers_text(close){
            this.changed_stickers = [];
            this.changed_text = [];
            this.axios_array_sticker_text = [];
            this.$nextTick(function () {
                this.update_banners();
                this.update_stickers();
                this.update_text();
                this.adjust_points();
                this.sticker_interaction();
                this.loading = false;
                if(close == 'close'){
                    this.closeSection();
                } 
            })            
        },
        loading_count(){
            let loadCount = this.changed.length + this.deleted.length + this.deleted_sticker_ids.length + this.deleted_text_ids.length;
            for(let banner in this.sale_send){
                if(!this.sale_send[banner].pivot.id){
                    loadCount++;
                }
            }
            this.load_count = loadCount;
        },
        loading_count_stickers_text(){
            let loadCount = this.changed_stickers.length + this.changed_text.length;
            for(let banner in this.sale_send){
                for(let sticker in this.prev_sale[banner].pivot.stickers){
                    if(!this.prev_sale[banner].pivot.stickers[sticker].pivot.id){
                        loadCount++;
                    }
                }
                for(let text in this.prev_sale[banner].pivot.texts){
                    if(!this.prev_sale[banner].pivot.texts[text].id){
                        loadCount++;
                    }
                }
            }
            this.load_count_stickers_text = loadCount;
        },
        closeSection (event) {
            this.destroy_adjust_points();
            history.pushState({page: 0}, "", window.location.pathname); 
            this.$emit('closeChild', false);
        },
        add_banner(){
            this.sale_send.push({
                    id: this.banner_list[0].id,
                    name: this.banner_list[0].name,
                    sizes: this.banner_list[0].sizes,
                    pivot:{
                        id: null,
                        stickers: [],
                        texts: [],
                        url: this.banner_url,
                        link: "",
                    }
                }
            );            
            this.update_banners('add_banner');
            this.update_stickers();  
            this.update_text();  
            this.banner_number();           
        },
        add_sticker(index, device){
            if(device == 'desktop'){
                this.sale_send[index].pivot.stickers.push(
                    {
                        id: this.sticker_model_desktop[index].id,
                        name: this.sticker_model_desktop[index].name,
                        images: {png: this.sticker_model_desktop[index].images.png},
                        pivot: {
                            banner_size_id: 1,
                            height: 'auto',
                            width: 100,
                            x: 0,
                            y: 0,
                        },
                    }
                )
            }
            if(device == 'mobile'){
                this.sale_send[index].pivot.stickers.push(
                    {
                        id: this.sticker_model_mobile[index].id,
                        name: this.sticker_model_mobile[index].name,
                        images: {png: this.sticker_model_mobile[index].images.png},
                        pivot: {
                            banner_size_id: 2,
                            height: 'auto',
                            width: 100,
                            x: 0,
                            y: 0,
                        },
                    }
                )
            }
            this.$nextTick(function () {
                this.sticker_interaction();
            });
        },
        add_text(index, device, type){
            let text = null
            let group = null            
            if(device == 'desktop'){
                if(type == 'text'){
                    text = this.desktop_text
                } else {
                    group = {
                        id: this.text_model_desktop[index].id
                    }
                }
                this.sale_send[index].pivot.texts.push(
                    {
                        colour: this.color,
                        text: text,
                        group: group,
                        font_size: 50,
                        font: {
                            id: this.font_id,
                            font: this.font_attr('font', this.font_id)
                        },
                        font_style: {
                            id: this.font_style_id,
                            slug: this.font_attr('style', this.font_style_id)
                        },
                        font_weight: {
                            id: this.font_weight_id,
                            weight: this.font_attr('weight', this.font_id, this.font_weight_id)
                        },
                        banner_size_id: 1,
                        height: 'auto',
                        width: 'auto',
                        x: 0,
                        y: 0,                        
                    }
                )
            }
            if(device == 'mobile'){
                if(type == 'text'){
                    text = this.mobile_text
                } else {
                    group = {
                        id: this.text_model_mobile[index].id
                    }
                }
                this.sale_send[index].pivot.texts.push(
                    {
                        colour: this.color,
                        text: text,
                        group: group,
                        font_size: 50,
                        font: {
                            id: this.font_id,
                            font: this.font_attr('font', this.font_id)
                        },
                        font_style: {
                            id: this.font_style_id,
                            slug: this.font_attr('style', this.font_style_id)
                        },
                        font_weight: {
                            id: this.font_weight_id,
                            weight: this.font_attr('weight', this.font_id, this.font_weight_id)
                        },
                        banner_size_id: 2,
                        height: 'auto',
                        width: 'auto',
                        x: 0,
                        y: 0,                        
                    }
                )
            }
            this.$nextTick(function () {
                this.sticker_interaction();
                this.desktop_text = '';
                this.mobile_text = '';
            });
        },
        has_text(type){
            for(let banner in this.sale_send){
                for(let text in this.sale_send[banner].pivot.texts){
                    if(this.sale_send[banner].pivot.texts[text].banner_size_id == 1 && type == 'desktop'){
                        return true;
                    } else if(this.sale_send[banner].pivot.texts[text].banner_size_id == 2 && type == 'mobile'){
                        return true;
                    }
                }
            }
            return false;
        },
        font_attr(type, id, weight_id){
            if(type == 'font'){
                for(let font in this.fonts){
                    if(this.fonts[font].id == id){
                        return this.fonts[font].font;
                    }
                }
            } else if(type == 'style') {
                for(let font in this.fontStyles){
                    if(this.fontStyles[font].id == id){
                        return this.fontStyles[font].slug;
                    }
                }
            } else {
                for(let font in this.fonts){
                    if(this.fonts[font].id == id){
                        for(let weight in this.fonts[font].weights){
                            if(this.fonts[font].weights[weight].id == weight_id){
                                return this.fonts[font].weights[weight].weight;
                            }
                        }
                    }
                }
            }
        },
        change_array(id, type){
            if(id){
                if(type == 'sticker' && !this.changed_stickers.includes(id)){
                    this.changed_stickers.push(id);
                } else if(type == 'text' && !this.changed_text.includes(id)){
                    this.changed_text.push(id);
                }            
                else if(!this.changed.includes(id) && !type){
                    this.changed.push(id);
                }
            }
        },
        delete_banner(index, id){
            this.sale_send.splice(index, 1); 
            this.banner_model.splice(index, 1); 
            this.sticker_model_desktop.splice(index, 1);
            this.sticker_model_mobile.splice(index, 1);  
            if(id){
                this.deleted.push(id);
            }
            this.banner_number();
        },
        delete_sticker(index, subindex, id, banner_id){
            this.sale_send[index].pivot.stickers.splice(subindex, 1); 
            if(id){
                this.deleted_sticker_ids.push(id);
                this.deleted_sticker_banner_ids.push(banner_id);
            }
        },
        delete_text(index, subindex, id, banner_id){
            this.sale_send[index].pivot.texts.splice(subindex, 1); 
            if(id){
                this.deleted_text_ids.push(id);
                this.deleted_text_banner_ids.push(banner_id);
            }
        },
        change_url(){
            this.selected_banner = null;            
        },
        adjust(value){
            if(this.$refs['banner_desktop']){
                let naturalWidth = this.$refs['banner_desktop'][this.selected_banner].naturalWidth;
                let width = this.$refs['banner_desktop'][this.selected_banner].width;
                let ratio = width / naturalWidth;            
                return value * ratio;
            }
        },
        adjust_mob(value){
            if(this.$refs['banner_mobile']){
                let naturalWidth = this.$refs['banner_mobile'][this.selected_banner].naturalWidth;
                let width = this.$refs['banner_mobile'][this.selected_banner].width;
                let ratio = width / naturalWidth;
                return value * ratio;
            }
        },
        post_adjust(value){
            if(this.$refs['banner_desktop']){
                let naturalWidth = this.$refs['banner_desktop'][this.selected_banner].naturalWidth;
                let width = this.$refs['banner_desktop'][this.selected_banner].width;
                let ratio = width / naturalWidth;     
                return Math.round(value / ratio);
            }
        },
        post_adjust_mob(value){
            if(this.$refs['banner_mobile']){
                let naturalWidth = this.$refs['banner_mobile'][this.selected_banner].naturalWidth;
                let width = this.$refs['banner_mobile'][this.selected_banner].width;
                let ratio = width / naturalWidth;
                return Math.round(value / ratio);
            }
        },
        dragMoveListener (event) {
            var target = event.target
            // keep the dragged position in the data-x/data-y attributes
            var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
            var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

            // translate the element
            target.style.webkitTransform =
            target.style.transform =
              'translate(' + x + 'px, ' + y + 'px)'

            // update the posiion attributes
            var bannerIndex = target.getAttribute('data-index');
            var stickerIndex = target.getAttribute('data-subindex');
            if(target.getAttribute('text')){
                this.sale_send[bannerIndex].pivot.texts[stickerIndex].x = x;
                this.sale_send[bannerIndex].pivot.texts[stickerIndex].y = y;
                this.sale_send[bannerIndex].pivot.texts[stickerIndex].width = event.rect.width;
                this.sale_send[bannerIndex].pivot.texts[stickerIndex].height = event.rect.height;
                this.sale_send[bannerIndex].pivot.texts[stickerIndex].font_size = event.rect.height;
            } else {
                this.sale_send[bannerIndex].pivot.stickers[stickerIndex].pivot.x = x;
                this.sale_send[bannerIndex].pivot.stickers[stickerIndex].pivot.y = y;
                this.sale_send[bannerIndex].pivot.stickers[stickerIndex].pivot.width = event.rect.width;
                this.sale_send[bannerIndex].pivot.stickers[stickerIndex].pivot.height = event.rect.height;
            }
        },
        resize_pick(){
            this.$nextTick(function () {
                this.sticker_interaction();
            });
        },
        sticker_interaction(){
            var send = this
            if(this.$refs['sticker'] || this.$refs['text']){
                interact('.sticker')
                .resizable({
                    // resize from all edges and corners
                    edges: { left: send.resizable, right: send.resizable, bottom: send.resizable, top: send.resizable },

                    listeners: {
                        move (event) {
                            var target = event.target
                            var x = (parseFloat(target.getAttribute('data-x')) || 0)
                            var y = (parseFloat(target.getAttribute('data-y')) || 0)

                            var bannerIndex = target.getAttribute('data-index');
                            var stickerIndex = target.getAttribute('data-subindex');

                            // update the element's style                            
                            target.style.height = event.rect.height + 'px' 
                            if(target.getAttribute('text')){
                                target.style.width = event.rect.width + 10 + 'px'
                                send.sale_send[bannerIndex].pivot.texts[stickerIndex].width = event.rect.width;
                                send.sale_send[bannerIndex].pivot.texts[stickerIndex].height = event.rect.height;
                                send.sale_send[bannerIndex].pivot.texts[stickerIndex].font_size = event.rect.height;
                            } else {
                                target.style.width = event.rect.width + 'px'
                                send.sale_send[bannerIndex].pivot.stickers[stickerIndex].pivot.width = event.rect.width;
                                send.sale_send[bannerIndex].pivot.stickers[stickerIndex].pivot.height = event.rect.height;
                            }                            

                            // translate when resizing from top or left edges
                            x += event.deltaRect.left
                            y += event.deltaRect.top

                            target.style.webkitTransform = target.style.transform =
                              'translate(' + x + 'px,' + y + 'px)'

                            target.setAttribute('data-x', x)
                            target.setAttribute('data-y', y)
                            if(target.getAttribute('text')){
                                send.sale_send[bannerIndex].pivot.texts[stickerIndex].x = x;
                                send.sale_send[bannerIndex].pivot.texts[stickerIndex].y = y;
                            } else {
                                send.sale_send[bannerIndex].pivot.stickers[stickerIndex].pivot.x = x;
                                send.sale_send[bannerIndex].pivot.stickers[stickerIndex].pivot.y = y;
                            }
                        }
                    },
                    modifiers: [
                        // keep the edges inside the parent
                        interact.modifiers.restrictEdges({
                            outer: 'parent'
                        }),

                        interact.modifiers.aspectRatio({
                        }),

                    ],

                    inertia: true
                })
                .draggable({
                    listeners: { move: this.dragMoveListener },
                    inertia: true,
                    modifiers: [
                        interact.modifiers.restrictRect({
                            restriction: 'parent',
                            endOnly: true
                        })
                    ]
                })
            }
        }
    },
};
</script>